import { Injectable } from '@angular/core';
import { ApiService } from './http/api.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private apiClient: ApiService) { }

  // Get All
  getCompanies(): any {
    return this.apiClient.get(`/company`);
  }
  // Get By Id
  getCompany(companyId: number): any {
    console.log("getCompany : ", companyId);
    return this.apiClient.get(`/company/${companyId}`);
  }
  // Post
  /*postCompany(companyId: number, model: any): any {
    return this.apiClient.post(`/company/${companyId}`, model);
  }*/
  postCompany(model: any): any {
    return this.apiClient.post(`/company`, model);
  }
  // Put
  putCompany(companyId: number, model: any): any {
    return this.apiClient.put(`/company/${companyId}`, model);
  }
  // Delete
  deleteCompany(companyId: number): any {
    return this.apiClient.delete(`/company/${companyId}`);
  }

  getAllCompany(): any {
    return this.apiClient.get(`/company/all`);
  }

  getAllProductGroup(companyId: number): any {
    return this.apiClient.get(`/${companyId}/product-groups/get-all`);
  }

  getSalesPosition(companyId: number) {
    return this.apiClient.get(`/${companyId}/sales-structures/sale-position`);
  }
}
